import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './style/Home.css';
import '../components/style/FAQ.css';
import imgRight from '../assets/img/beonwallhero.png';
import { FaCameraRetro, FaMagic, FaKeyboard, FaTv, FaCheck, FaDownload, FaBolt, FaQrcode, FaPaintBrush, FaCommentDots, FaLock, FaTimes, FaRobot} from 'react-icons/fa';
import { BsQrCode } from "react-icons/bs";
import { MdOutlineScreenshotMonitor } from "react-icons/md";
import imagemariage from '../assets/img/mariage-Photoroom.png';
import imagefetereli from '../assets/img/fetereli-Photoroom.png';
import imageevgevj from '../assets/img/EVG_EVJ-Photoroom.png';
import imagecompanyparty from '../assets/img/companyparty-Photoroom.png';
import imagebirthday from '../assets/img/birthday-Photoroom.png';
import imagebabyshower from '../assets/img/BabyShower-Photoroom.png';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import { FadeInSection } from '../components/useInViewOnce';
import FeatureSteps from '../components/FeatureStepTabs'; // adapte le chemin
import LottieIcon from '../components/LottieIcon'; // adapte le chemin si besoin
import clickAnimation from '../assets/animations/click.json';
import photoAnimation from '../assets/animations/photo.json';
import signupAnimation from '../assets/animations/signin_button_click.json';
import ArrowAnimation from '../assets/animations/arrow.json';
import { Helmet } from 'react-helmet-async';
import VideoModal from '../components/VideoModal'; // adapte le chemin
import PromoPopup from "../components/PromoPopup";




const typingSpeed = 150;
const erasingSpeed = 75;
const delayBetweenWords = 1500;

function Home() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const words = [t('Weeding'), t('Birthday'), t('Party')];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [isVideoOpen, setIsVideoOpen] = useState(false);



  useEffect(() => {
    const currentWord = words[currentIndex];
    let timeout;

    if (isDeleting) {
      if (displayedText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayedText((prev) => prev.slice(0, -1));
        }, erasingSpeed);
      } else {
        setIsDeleting(false);
        setCurrentIndex((prev) => (prev + 1) % words.length);
      }
    } else {
      if (displayedText.length < currentWord.length) {
        timeout = setTimeout(() => {
          setDisplayedText(currentWord.slice(0, displayedText.length + 1));
        }, typingSpeed);
      } else {
        timeout = setTimeout(() => setIsDeleting(true), delayBetweenWords);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayedText, isDeleting, currentIndex]);


  
  return (
    <>
      {/* Popup promo qui s'affiche à l’arrivée sur la home */}
      <PromoPopup
        promoCode="BLACKFRIDAY50"
        title="🎉 Offre de Black Friday"
        message="Profite de -50% sur toutes les offres avec le code ci-dessous."
      />
       <Helmet>
      {/* --- SEO classique --- */}
      <title>BeOnWall – {t('heroTitle')} {t('heroTitle2')}</title>
      <meta name="description" content={t('heroSubtext')} />
      <meta name="keywords" content="BeOnWall, QR code, photo en direct, live photo, album numérique, photowall, livre d'or numérique, photo booth app, photo stream, wedding captions, guestbook, candid photo, qr scan, create qr code, link to qr, scan qr code from image, soirée, mariage, anniversaire, événement interactif" />
      <meta name="author" content="BeOnWall" />
      <meta name="robots" content="index, follow" />

      {/* --- Open Graph (Facebook, Instagram, LinkedIn) --- */}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={`BeOnWall – ${t('heroTitle')} ${t('heroTitle2')}`} />
      <meta property="og:description" content={t('heroSubtext')} />
      <meta property="og:url" content="https://www.beonwall.com/" />
      <meta property="og:site_name" content="BeOnWall" />
      <meta property="og:image" content="https://www.beonwall.com/assets/beonwall-1200x630.png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* --- Twitter Card --- */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`BeOnWall – ${t('heroTitle')} ${t('heroTitle2')}`} />
      <meta name="twitter:description" content={t('heroSubtext')} />
      <meta name="twitter:image" content="https://www.beonwall.com/assets/beonwall-1200x630.png" />
      <meta name="twitter:site" content="@BeOnWall" />
      <meta name="twitter:creator" content="@BeOnWall" />

      {/* --- TikTok & Snapchat --- */}
      <meta name="application-name" content="BeOnWall" />
      <meta name="apple-mobile-web-app-title" content="BeOnWall" />
      <meta name="theme-color" content="#000000" />

      {/* --- Canonical link --- */}
      <link rel="canonical" href="https://www.beonwall.com/" />

      {/* --- JSON-LD --- */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "BeOnWall nécessite-il une application pour participer ?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Non, aucune application ni inscription n’est requise. Les invités participent via un QR code ou un lien. C’est tellement simple que même mamie peut le faire."
                }
              },
              {
                "@type": "Question",
                "name": "Peut-on télécharger toutes les photos et message des invités ?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Oui ! Vous pouvez tout télécharger dans un dossier compressé ou individuellement. Les invités ne peuvent pas télécharger."
                }
              },
              {
                "@type": "Question",
                "name": "Le QR code est-il disponible avant un événement pour l’imprimer ou le partager?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Oui ! Imprimez-le sur des tables ou à l’entrée. Les invités peuvent scanner et téléverser en toute simplicité."
                }
              },
              {
                "@type": "Question",
                "name": "Comment utiliser le diaporama end direct ?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Le Mur de Photos est un diaporama en direct mis à jour en temps réel. Affichez-le sur n’importe quel écran connecté à Internet."
                }
              },
              {
                "@type": "Question",
                "name": "Mes photos sont-elles privées ?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Oui. Vous contrôlez leur visibilité. Nous ne les utilisons pas, ne les stockons pas, et ne les partageons pas."
                }
              },
              {
                "@type": "Question",
                "name": "Nous avons déjà un photographe, est-ce utile ?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Oui ! Les invités offrent des moments spontanés que le photographe pourrait rater. Les deux se complètent parfaitement."
                }
              },
              {
                "@type": "Question",
                "name": "Un invité peut-il partager une une photo ou un message inappropriée ?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Nous détectons automatiquement la plupart des problèmes, et vous pouvez supprimer manuellement ou activer une modération."
                }
              },
              {
                "@type": "Question",
                "name": "Peut-on utiliser BeOnWall partout dans le monde ?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Oui, tant qu’une connexion Internet est disponible."
                }
              }
            ]
          })}
        </script>
    </Helmet>
    <div className="home-page">
      <div className="home-wrapper">
        {/* Hero Section */}
        <FadeInSection className="home-hero">
          <div className="home-left">
            
            <h1>
             {t('heroTitle')}<br />
              {t('heroTitle2')} <span className="highlight" style={{ minWidth: '130px', display: 'inline-block' }}>{displayedText}</span>
            </h1>
            <p className="subtext">
              {t('heroSubtext')}
            </p>
            <div className="home-buttons">
              <button className="gold-btn" onClick={() => navigate('/login')}>{t('createEvent')}</button>
              <button className="secondary-btn" onClick={() => setIsVideoOpen(true)}>
                {t('watchHow')}
              </button>

            </div>
            <p className="setup-note">{t('setupNote')}</p>
          </div>
          <div className="home-right">
            <img src={imgRight} alt="event preview" className="hero-img" />
          </div>      
      </FadeInSection>


                {/* How it works Section */}
        
                <div className="step-box-wrapper">
                  <FadeInSection className="step step1-offset">
                    <div className="step-text">
                      <strong>{t('step1')}</strong><br />{t('step1img')}
                    </div>
                    <div className="step-animation">
                      <LottieIcon animationData={signupAnimation} size={100} />
                    </div>
                  </FadeInSection>

                  <div className="arrow-wrapper">
                    <LottieIcon animationData={ArrowAnimation} />
                  </div>

                  <FadeInSection className="step">
                    <div className="step-text step-text-offset">
                      <strong>{t('step2')}</strong><br />{t('step2img')}
                    </div>
                    <div className="step-animation2">
                      <LottieIcon animationData={clickAnimation} />
                    </div>
                  </FadeInSection>

                  <div className="arrow-wrapper">
                    <LottieIcon animationData={ArrowAnimation} />
                  </div>

                  <FadeInSection className="step">
                    <div className="step-text step-text-offset">
                      <strong>{t('step3')}</strong><br />{t('step3img')}
                    </div>
                    <div className="step-animation2">
                      <LottieIcon animationData={photoAnimation} />
                    </div>
                  </FadeInSection>
                </div>


        {/* Features Section */}
            <FadeInSection className="home-features">
              <h2>{t("featuresTitle")}</h2>
              <p>{t("featuresSub")}</p>
              <button className="gold-btn" onClick={() => navigate("/login")}>
                Get Started
              </button>

              <div className="features-layout">
                {/* Colonne gauche */}
                <div className="feature-col feature-float-left">
                  <div className="feature-block">
                    <FaCameraRetro className="feature-icon" />
                    <h4>{t("features.photoVideoTitle")}</h4>
                    <p>{t("features.photoVideoText")}</p>
                  </div>
                  <div className="feature-block">
                    <FaRobot className="feature-icon" />
                    <h4>{t("features.textCaptionTitle")}</h4>
                    <p>{t("features.textCaptionText")}</p>
                  </div>
                </div>

                {/* Image centrale */}
                <div className="central-image">
                 <div className="phone-frame">
                <div className="top-notch"></div>
                <video
                  src="/video/uploadcom.mp4"
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="features-video"
                />
              </div>



                </div>

                {/* Colonne droite */}
                <div className="feature-col feature-float-right">
                  <div className="feature-block">
                    <BsQrCode className="feature-icon" />
                    <h4>{t("features.easyUseTitle")}</h4>
                    <p>{t("features.easyUseText")}</p>
                  </div>
                  <div className="feature-block">
                    <MdOutlineScreenshotMonitor className="feature-icon" />
                    <h4>{t("features.slideshowTitle")}</h4>
                    <p>{t("features.slideshowText")}</p>
                  </div>
                </div>
              </div>
            </FadeInSection>
        {/* Feature 2  Section */}
          <FadeInSection>
            <FeatureSteps />
          </FadeInSection>
        {/* How It Works Section */}
       
        {/* Call to Action Section */}
  
      <FadeInSection className="perfect-event">  
        <h2>{t('perfectEventTitle')}</h2>
        <p className="event-subtitle">{t('perfectEventSub')}</p>

        <div className="event-grid">
          <div className="upload-page-container event-box">
            <h4><FaCameraRetro className="event-icon" /> {t('eventFeatures.album')}</h4>
            <p>{t('eventFeaturestext.album')}</p>
          </div>
          <div className="upload-page-container event-box">
            <h4><FaDownload className="event-icon" /> {t('eventFeatures.download')}</h4>
            <p>{t('eventFeaturestext.download')}</p>
          </div>
          <div className="upload-page-container event-box">
            <h4><FaBolt className="event-icon" /> {t('eventFeatures.noApp')}</h4>
            <p>{t('eventFeaturestext.noApp')}</p>
          </div>
          <div className="upload-page-container event-box">
            <h4><FaQrcode className="event-icon" /> {t('eventFeatures.qr')}</h4>
            <p>{t('eventFeaturestext.qr')}</p>
          </div>
          <div className="upload-page-container event-box">
            <h4><FaTv className="event-icon" /> {t('eventFeatures.wall')}</h4>
            <p>{t('eventFeaturestext.wall')}</p>
          </div>
          <div className="upload-page-container event-box">
            <h4><FaPaintBrush className="event-icon" /> {t('eventFeatures.custom')}</h4>
            <p>{t('eventFeaturestext.custom')}</p>
          </div>
          <div className="upload-page-container event-box">
            <h4><FaCommentDots className="event-icon" /> {t('eventFeatures.caption')}</h4>
            <p>{t('eventFeaturestext.caption')}</p>
          </div>
          <div className="upload-page-container event-box">
            <h4><FaLock className="event-icon" /> {t('eventFeatures.secure')}</h4>
            <p>{t('eventFeaturestext.secure')}</p>
          </div>
        </div>  
      </FadeInSection>
      {/* Occasion Section */}
      {/*
      <FadeInSection>
        <RibbonBanner text={t('occasionBanner')} />
      </FadeInSection>
        {/* Occasion Section */}
        <FadeInSection className="event-types">
          <h2>{t('eventTypesTitle')}</h2>
          <p className="event-subtitle">{t('eventTypesSub')}</p>

          <div className="event-types-grid">
            <div className="event-type-card float-hz">
              <img src={imagemariage} alt="Mariage" />
              <p>{t('eventTypes.wedding')}</p>
            </div>
            <div className="event-type-card float-hz">
              <img src={imagefetereli} alt="Fêtes religieuses" />
              <p>{t('eventTypes.religiousfestival')}</p>
            </div>
            <div className="event-type-card float-hz">
              <img src={imagecompanyparty} alt="Fête d'entreprise" />
              <p>{t('eventTypes.party')}</p>
            </div>
            <div className="event-type-card float-hz">
              <img src={imagebirthday} alt="Anniversaire" />
              <p>{t('eventTypes.birthday')}</p>
            </div>
            <div className="event-type-card float-hz">
              <img src={imageevgevj} alt="EVJF / EVG" />
              <p>{t('eventTypes.bachelorparty')}</p>
            </div>
            <div className="event-type-card float-hz">
              <img src={imagebabyshower} alt="Baby Shower" />
              <p>{t('eventTypes.babyShower')}</p>
            </div>
          </div>

          <button className="gold-btn guide-btn" onClick={() => navigate('/guides')}>
            {t('guide')}
          </button>
        </FadeInSection>

        {/* Testimonials Section */}
        <FadeInSection className="testimonials-section">    
          <h2>{t('testimonialsTitle')}</h2>
          <p className="subtext">
            {t('testimonialsSub')}
          </p>
          <p className="subtext">
            {/*<span className="rating">{t('rated')} </span>*/}
             {/*<span className="read-reviews" onClick={() => navigate('/Walloflove')}>{t('readReviews')}</span>*/}
          </p>

          <div className="testimonials-grid">   
            <div className="testimonial-card">
              <div className="testimonial-tag">Mariage</div>
              <div className="testimonial-header">
                <span className="stars">★★★★★</span>
                <span className="user">Sophie & Karim</span>
              </div>
              <p>"Be On Wall a été la touche magique de notre mariage ! Voir en direct les photos et messages de nos invités projetés pendant la soirée, c’était émouvant et drôle à la fois. Aucun téléchargement, juste un scan et tout le monde a participé, même ma grand-mère ! Un vrai coup de cœur."</p>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-tag">Anniversaire</div>
              <div className="testimonial-header">
                <span className="stars">★★★★★</span>
                <span className="user">Nicolas B.</span>
              </div>
              <p>"Franchement génial ! Pour mes 30 ans, mes amis ont partagé des selfies, des souvenirs et même des vœux en live. Tout s’affichait sur écran géant, ambiance garantie ! Be On Wall a rendu la soirée encore plus interactive et mémorable."</p>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-tag">Événement d’entreprise</div>
              <div className="testimonial-header">
                <span className="stars">★★★★★</span>
                <span className="user">Julie M., Chez NovaCorp</span>
              </div>
              <p>"Nous avons utilisé Be On Wall pour notre séminaire annuel : simple à mettre en place, très intuitif pour les participants, et un vrai plus pour créer du lien. Les photos et messages ont animé nos pauses et créé un vrai moment de partage. Bravo pour cette innovation !"</p>
            </div>
          </div>
        </FadeInSection>

        {/* Comparison Section */}
          <FadeInSection className="comparison-section">
            <h2>{t('comparisonTitle')} <span className="highlight-gold">{t('Seriously')}</span></h2>
            <p className="subtext">{t('comparisonSub')}</p>

            <div className="comparison-wrapper">
              <div className="comparison-col">
                <h3 className="column-title gold-title">{t('comparison.ours')}</h3>
                <ul className="comparison-list">
                  <li><FaCheck className="check-iconn" /> {t('comparison.oursList.1')}</li>
                  <li><FaCheck className="check-iconn" /> {t('comparison.oursList.2')}</li>
                  <li><FaCheck className="check-iconn" /> {t('comparison.oursList.3')}</li>
                  <li><FaCheck className="check-iconn" /> {t('comparison.oursList.4')}</li>
                  <li><FaCheck className="check-iconn" /> {t('comparison.oursList.5')}</li>
                  <li><FaCheck className="check-iconn" /> {t('comparison.oursList.6')}</li>
                </ul>
              </div>
              <div className="comparison-col">
                <h3 className="column-title">{t('comparison.theirs')}</h3>
                <ul className="comparison-list">
                  <li><FaTimes className="x-icon" /> {t('comparison.theirsList.1')}</li>
                  <li><FaTimes className="x-icon" /> {t('comparison.theirsList.2')}</li>
                  <li><FaTimes className="x-icon" /> {t('comparison.theirsList.3')}</li>
                  <li><FaTimes className="x-icon" /> {t('comparison.theirsList.4')}</li>
                  <li><FaTimes className="x-icon" /> {t('comparison.theirsList.5')}</li>
                  <li><FaTimes className="x-icon" /> {t('comparison.theirsList.6')}</li>
                </ul>
              </div>
            </div>
          </FadeInSection>
        {/* Statistics Section */}
          <FadeInSection className="stats-section">
            <div className="stats-wrapper">
              <h2 className="stats-title">Ils nous font <span className="highlight-gold">confiance</span></h2>
              <div className="stats-container">
                <div className="stat-item">
                  <h3>150+</h3>
                  <p>{t('Stats.EventCreated')}</p>
                </div>
                <div className="stat-item">
                  <h3>98%</h3>
                  <p>{t('Stats.TauxSatisfaction')}</p>
                </div>
                <div className="stat-item">
                  <h3>3k+</h3>
                  <p>{t('Stats.TotalImages')}</p>
                </div>
              </div>
            </div>
          </FadeInSection>



      </div>
        {/* FAQ Section */}
        <FadeInSection>   
          <FAQSection />
        </FadeInSection>

        {/* Footer Section */}
        <FadeInSection>  
          <Footer />
        </FadeInSection>
        
        <VideoModal isOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} />

      

      </div>
    </>
  );
}

export default Home;
